import { useNavigate } from "react-router-dom";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useEffect, useState } from "react";
import { getBasicObjectTypeLayer, getAllObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { getObjectsOnWMSLayer } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { objectTypesDefaultFilters } from "../mapObjectType";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { mapLayersDict } from "../mapLayersDict";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapGeoMarkers() {
    const navigate = useNavigate();
    const mapName = "GeoMarkers"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let layerFilter = objectTypesDefaultFilters.hasOwnProperty(mapName) ? objectTypesDefaultFilters[mapName] : null
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
    }, []);

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnWMSLayer(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} />
                <MapOverlayWidget />
            </div>
        </>
    )
}
